import { configureStore } from "@reduxjs/toolkit";
import businessAccessReducer from "./slices/businessAccessSlice";

export const store = configureStore({
  reducer: {
    businessAccess: businessAccessReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


